// AuthContext.js
import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from './store/actions/auth';
import { bumpAuthSession } from './authSession';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.profile);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const loading = useSelector((state) => state.user.loading);

  useEffect(() => {
    const localToken = localStorage.getItem('token');

    if (!localToken) {
      bumpAuthSession();
      dispatch({ type: 'LOGOUT' });
      return;
    }

    if (!user?._id) {
      dispatch(getProfile());
    }
  }, [dispatch, user?._id]);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
